import { Routes, Route } from "react-router-dom";
import SitesList from "./SitesList";
import SiteDetail from "./SiteDetail";
import SiteForm from "./SiteForm";
import DiseaseAreasRoutes from "./diseaseAreas";
import StudiesRoutes from "./studies";
import OrganizationsRoutes from "./organizations";
import LocationsRoutes from "./locations";
import InvestigatorsRoutes from "./investigators";
import ParticipationsRoutes from "./participations";

export default function SitesRoutes() {
  return (
    <Routes>
      <Route index element={<SitesList />} />
      <Route path="new" element={<SiteForm />} />
      <Route path="disease-areas/*" element={<DiseaseAreasRoutes />} />
      <Route path="studies/*" element={<StudiesRoutes />} />
      <Route path="organizations/*" element={<OrganizationsRoutes />} />
      <Route path="locations/*" element={<LocationsRoutes />} />
      <Route path="investigators/*" element={<InvestigatorsRoutes />} />
      <Route path="participations/*" element={<ParticipationsRoutes />} />
      <Route path=":id" element={<SiteDetail />} />
      <Route path=":id/da/:da_code" element={<SiteDetail />} />
      <Route path=":id/edit" element={<SiteForm />} />
    </Routes>
  );
}
